const resources = { showMore: 'Show more' };

module.exports = function getResource(label) {
    return resources[label];
};
